import { LiveblocksState, COMMENT_FILTER } from './types';

export const initialState: LiveblocksState = {
  isCommentingMode: false,
  centerCommentRequested: 0,
  showCommentThreads: true,
  commentFilter: COMMENT_FILTER.UNRESOLVED,
  openComments: [],
  targetThreadId: null,
};
